import { render, staticRenderFns } from "./PopuList.vue?vue&type=template&id=a9809f68&scoped=true&"
import script from "./PopuList.vue?vue&type=script&lang=js&"
export * from "./PopuList.vue?vue&type=script&lang=js&"
import style0 from "./PopuList.vue?vue&type=style&index=0&id=a9809f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9809f68",
  null
  
)

export default component.exports